module.exports = __webpack_public_path__ + "staticcomp/img/content_1副本.bd53ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/2/content_1副本.jpg
// module id = Fg6h
// module chunks = 39